import {Route, RouterModule}     from '@angular/router';
import {PageMode}                from '../ap-interface';
import {NgModule}                from '@angular/core';
import {FieldOverviewComponent}  from './components/field-overview.component';
import {ApPageNotFoundComponent} from '../layout/components/ap-page-not-found.component';
import {ApPermissionGuard}       from '../guards/ap-permission-guard.service';
import {ApCropRotationComponent} from './components/ap-crop-rotation/ap-crop-rotation.component';
import {ApDeactivateGuard}       from '../guards/ap-deactivate.guard';
import {ApSamplefieldsComponent} from './components/ap-samplefields/ap-samplefields.component';
import {NdiComponent}            from './components/ndi/ndi.component';
import {ApElevationComponent}    from './components/ap-elevation.component';
import {ApSoilScanComponent}     from './components/ap-soil-scan.component';
import {MonitoringComponent}     from './components/ap-monitoring/monitoring.component';

const routes: Route[] = [
  {
    path: 'overview',
    component: FieldOverviewComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
  {
    path: 'crop-rotation',
    component: ApCropRotationComponent,
    canActivate: [ApPermissionGuard],
    canDeactivate: [ApDeactivateGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
  {
    path: 'takeover-fields',
    component: ApPageNotFoundComponent,
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'soil-sample-fields',
    component: ApSamplefieldsComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'conversion',
    component: ApPageNotFoundComponent,
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'satellite',
    component: NdiComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
  {
    path: 'elevation',
    component: ApElevationComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    },
  },
  {
    path: 'soil-scanner',
    component: ApSoilScanComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'monitoring',
    component: MonitoringComponent,
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class ApFieldmanagementRoutes {
}
